exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agbContainer{ font-weight: 300; font-size: var(--small);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    /* background-color: #f1f5da; */\n    /* background-color: hsla(199, 18%, 92%, 1); */\n    margin: 40px 30px 10px 30px;\n    padding: 20px;\n    /*font-size: var(--agb_font_size);*/\n    color: #4c4c4c;\n}\n\n#img{\n    flex-grow: 1;\n    height: var(--small);\n    margin: 0 6px 0 0;\n    opacity: 0.75;\n}\n\n#txt{\n    flex-grow: 3;\n}\n\na{\n    text-decoration: none;\n    color: #2c7199;\n    font-weight: bold;\n}", ""]);

// exports
